export function shouldDisplayAutoMpsFeatures(appContext) {
  const autoMpsState = appContext?.packages?.autoMps ?? {allowed: false, enabled: false}
  return autoMpsState.enabled && autoMpsState.allowed
}
